/**
 * QuestionTypeSelector — the icon grid shown as step 1 of adding a question
 * (WCR parity). Picking a type advances to the details editor.
 */
import { QUESTION_TYPE_META } from './formMeta';

interface QuestionTypeSelectorProps {
  onSelect: (type: string) => void;
  /** Offer only these type values (the prescreen supports a subset); all when omitted. */
  types?: string[];
}

export default function QuestionTypeSelector({ onSelect, types }: QuestionTypeSelectorProps) {
  const shown = types ? QUESTION_TYPE_META.filter((t) => types.includes(t.value)) : QUESTION_TYPE_META;
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      {shown.map(({ value, label, description, icon: Icon }) => (
        <button
          key={value}
          type="button"
          onClick={() => onSelect(value)}
          className="flex flex-col items-center rounded-lg border-2 border-gray-200 p-4 text-center transition-colors duration-150 hover:border-primary-500 hover:bg-primary-50 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:border-gray-600 dark:hover:border-primary-500 dark:hover:bg-primary-900/20"
        >
          <Icon className="mb-2 h-6 w-6 text-gray-500 dark:text-gray-400" />
          <span className="text-sm font-medium text-gray-900 dark:text-gray-100">{label}</span>
          <span className="mt-1 text-xs text-gray-500 dark:text-gray-400">{description}</span>
        </button>
      ))}
    </div>
  );
}
